import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";


// 查詢所有公司清單
export const queryAllCompaniesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010201'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010201")}`, method: 'post', data: ReqBody })
}

export const queryConsultantRelationshipList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010203'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010203")}`, method: 'post', data: ReqBody })
}

// 開通帳戶 before
export const B2010202Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010202",true)}`, method: 'post', data: ReqBody })
}

// 開通帳戶
export const updateCompaniesEffective = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010202")}`, method: 'post', data: ReqBody })
}

//新增公司關聯設定
export const createConsultantRelationship = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010205'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010205")}`, method: 'post', data: ReqBody })
}

//公司關聯設定移除  
export const deleteConsultantRelationship = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010204'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010204")}`, method: 'post', data: ReqBody })
}

//授權展延 before
export const B2010206Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010206'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010206",true)}`, method: 'post', data: ReqBody })
}

//授權展延
export const updateCompaniesEffectiveInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010206'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010206")}`, method: 'post', data: ReqBody })
}

export const deleteCompanyAccount = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010207'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010207")}`, method: 'post', data: ReqBody })
}

